import React, { useEffect, useMemo, useState } from "react";
import {
	Button,
	TextArea,
	Text,
	SelectBox,
	Img,
	Heading,
	Header,
	DefaultSideBar,
} from "../../components";
import { useLocation } from "react-router-dom";
import { detailOriginator, actionKyc, actionStatus } from "services/originator";
import { useNavigate } from "react-router";
import { dropDownOptions } from "constant/options";
import * as loader from "../../components/Loading/loading";

export default function DetailFundManager() {
	const navigate = useNavigate();
	const location = useLocation();
	const queryParams = new URLSearchParams(location.search);
	const [data, setData] = useState(null);
	const [status, setStatus] = useState("");
	const [reason, setReason] = useState("");
	const [submitError, setSubmitError] = useState("");
	const [isLoading, setIsLoading] = useState(false);
	const id = queryParams.get("id");

	const fetchData = async () => {
		try {
			const response = await detailOriginator(id);
			setData(response.data.registration_data);
		} catch (error) {
			console.log("Error fetching data:", error);
		}
	};

	const handleActionKyc = async () => {
		loader.showLoader();
		setIsLoading(true);
		try {
			const response = await actionKyc(status, reason, id);
			setIsLoading(false);
			if (response) {
				navigate(-1)
				// navigate("/fund-manager");
			}
		} catch (error) {
			setSubmitError(error);
		} finally {
			loader.hideLoader();
		}
	};

	const handleStatus = async () => {
		loader.showLoader();
		try {
			const response = await actionStatus(id, status === "approved");
			if (response) {
				window.location.reload();
			}
		} catch (error) {
			console.log("error action status");
		} finally {
			loader.hideLoader();
		}
	};

	function openPDFInNewTab(url) {
		// const fileId = url.split("id=")[1];
		// const newUrl = `https://drive.google.com/file/d/${fileId}/view`;
		window.open(url, "_blank");
	}

	const _status = useMemo(() => {
		if (!data) return "";

		if (data.is_active) {
			return data.kyc_status.charAt(0).toUpperCase() + data.kyc_status.slice(1);
		}

		return "Suspend";
	}, [data]);

	useEffect(() => {
		fetchData();
	}, [id]);

	return (
		<div className=" w-full relative bg-white-A700 pl-[81px] pt-[10vh]">
			<Header />
			<DefaultSideBar />
			<div className="flex flex-row justify-start p-[27px]">
				{data && !isLoading ? (
					<div className="flex flex-col justify-center w-full ml-2 p-[43px] border-blue_gray-100_01 border border-solid bg-white-A700 rounded-[10px]">
						<div className="grid grid-cols-3 gap-x-8 justify-between p-5 w-full">
							<div className="flex flex-col items-start justify-start w-full gap-4">
								<Heading size="2xl" as="h1" className="!mb-5">
									Organization Detail
								</Heading>
								<div className="flex flex-col items-start justify-start gap-2">
									<Text size="xl" as="p" className="!text-blue_gray-700">
										Company Name:
									</Text>
									<Heading as="h5">{data.company}</Heading>
								</div>
								<div className="flex flex-col items-start justify-start gap-2">
									<Text size="xl" as="p" className="!text-blue_gray-700">
										Address:
									</Text>
									<Heading as="h6">{data.address}</Heading>
								</div>
								<div className="flex flex-col items-start justify-start gap-2">
									<Text size="xl" as="p" className="!text-blue_gray-700">
										License Number:
									</Text>
									<Heading as="h6">{data.registration_skm_number ?? '-'}</Heading>
								</div>
								<div className="flex flex-col items-start justify-start gap-2">
									<Text size="xl" as="p" className="!text-blue_gray-700">
										Phone Number:
									</Text>
									<Heading as="h6">{data.company_phone ?? '-'}</Heading>
								</div>
							</div>
							<div className="flex flex-col items-start justify-start w-full">
								<Heading size="2xl" as="h1">
									Bank Account
								</Heading>
								<div className="flex flex-col gap-5 mt-8">
									<div className="flex flex-col items-start justify-start gap-2">
										<Text size="xl" as="p" className="!text-blue_gray-700">
											Bank Name:
										</Text>
										<Heading as="h5">{data.bank_name}</Heading>
									</div>
									<div className="flex flex-col items-start justify-start gap-2">
										<Text size="xl" as="p" className="!text-blue_gray-700">
											Account Name
										</Text>
										<Heading as="h6">{data.bank_account_name}</Heading>
									</div>
									<div className="flex flex-col items-start justify-start gap-2">
										<Text size="xl" as="p" className="!text-blue_gray-700">
											Account Number
										</Text>
										<Heading as="h6">{data.bank_account_number}</Heading>
									</div>
									<div className="flex flex-col items-start justify-start gap-2">
										<Text size="xl" as="p" className="!text-blue_gray-700">
											Status
										</Text>
										<Heading as="h6">{_status}</Heading>
									</div>
									{data.kyc_status === "rejected" ? (
										<div className="flex flex-col items-start justify-start gap-2">
											<Text size="xl" as="p" className="!text-blue_gray-700">
												Reject Reason
											</Text>
											<Heading as="h6">{data.kyc_rejection_reason}</Heading>
										</div>
									) : null}
								</div>
							</div>
							<div className="flex flex-col items-start justify-start w-full">
								<Heading size="2xl" as="h1">
									Representative Account
								</Heading>
								<div className="flex flex-col gap-5 mt-8">
									<div className="flex flex-col items-start justify-start gap-2">
										<Text size="xl" as="p" className="!text-blue_gray-700">
											Name:
										</Text>
										<Heading as="h5">{data.fullname}</Heading>
									</div>
									<div className="flex flex-col items-start justify-start gap-2">
										<Text size="xl" as="p" className="!text-blue_gray-700">
											Email:
										</Text>
										<Heading as="h6">{data.email}</Heading>
									</div>
									<div className="flex flex-col items-start justify-start gap-2">
										<Text size="xl" as="p" className="!text-blue_gray-700">
											Phone Number:
										</Text>
										<Heading as="h6">{data.phone}</Heading>
									</div>
								</div>
							</div>
						</div>

						<div className="flex flex-col justify-start gap-2 p-5">
							<Text size="xl" as="p" className="!text-blue_gray-700">
								License:
							</Text>
							{data.file_compro?.map(file => (
								<Text as="h6" key={file} className="!text-black-900 hover:underline hover:cursor-pointer" onClick={() => openPDFInNewTab(file)}>
									{file}
								</Text>
							))}
						</div>

						{data.kyc_status !== "rejected" && data.kyc_status !== "pending" ? (
							<>
								<div className="flex flex-col items-center justify-start w-full max-w-[200px] gap-[7px] mt-8 px-5">
									<div className="flex flex-row justify-start w-full">
										<Heading
											size="lg"
											as="p"
											className="!text-blue_gray-900_01 !font-opensans"
										>
											Action {data.kyc_status === "awaiting" ? "KYC" : "Suspension"}
										</Heading>
									</div>
									<SelectBox
										indicator={
											<Img
												src="images/img_icon_field_clear.svg"
												alt="Icon / Field / Clear"
											/>
										}
										name="rejected"
										placeholder="Select Status"
										options={
											data.kyc_status === "awaiting"
												? dropDownOptions
												: [
													{ label: "Suspend", value: "suspend" },
													{ label: "Unsuspend", value: "approved" },
												]
										}
										onChange={(value) => {
											setStatus(value.value);
										}}
										className="w-full gap-px font-opensans border-gray-300_01 border border-solid !rounded-lg"
									/>
								</div>
								{status === "rejected" && (
									<div className="flex flex-row justify-start w-full p-5">
										<div className="flex flex-col items-start justify-start w-full pt-0.5 gap-1.5">
											<Text as="p" className="!text-blue_gray-700 !font-medium">
												Reject Reason
											</Text>
											<TextArea
												onChange={(e) => {
													setReason(e);
												}}
												name="input_one"
												placeholder="Enter your reject reason"
												className="w-full text-blue_gray-500"
											/>
										</div>
									</div>
								)}
								<div className="flex justify-center w-full">
									<Button
										onClick={() => {
											if (data.kyc_status === "awaiting") {
												handleActionKyc();
											} else {
												handleStatus();
											}
										}}
										color="indigo_900"
										size="md"
										disable={status === ""}
										className="mt-[50px] tracking-[0.40px] font-poppins uppercase font-medium w-[183px] "
									>
										Update
									</Button>
								</div>
							</>
						) : null}

						{submitError && (
							<Text as="p" className="text-red-500">
								{submitError}
							</Text>
						)}
					</div>
				) : (
					<div className="flex w-full h-[90vh] justify-center items-center">
						Loading...
					</div>
				)}
			</div>
		</div>
	);
}
